export const API_BASE_URL = "https://quizandpass.wir.hochschule-trier.de:443/api";
//export const API_BASE_URL = "http://localhost:8080/api";

export function convertRemToPixels(rem) {
    return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}

export function numberOfCardsPerRow() {
    let maxWidth = window.innerWidth;
    return Math.floor(maxWidth / convertRemToPixels(19 + 1));
}